/* unplugin-vue-components disabled */import script from "./input-select.vue?vue&type=script&setup=true&lang=js"
export * from "./input-select.vue?vue&type=script&setup=true&lang=js"

import "./input-select.vue?vue&type=style&index=0&id=c84f3874&lang=scss"

const __exports__ = script;

export default __exports__